var map = {
	"./baldurs-gate-3.webp": 845,
	"./call-of-duty.webp": 965,
	"./dd2.webp": 801,
	"./elden-ring.webp": 218,
	"./fortnite.webp": 418,
	"./genshin-impact.webp": 857,
	"./god-of-war-ragnarok.webp": 289,
	"./gta.webp": 877,
	"./halo-infinite.webp": 70,
	"./minecraft.webp": 710,
	"./persona-5.webp": 688,
	"./pokemon-ecarlate-violet.webp": 660,
	"./red-dead-redemption-2.webp": 545,
	"./roblox.webp": 522,
	"./sims-4.webp": 86,
	"./skyrim.webp": 501,
	"./super-mario-bros-wonder.webp": 831,
	"./the-witcher-3.webp": 229,
	"./uncharted-4.webp": 345,
	"./warframe.webp": 82,
	"./zelda-botw.webp": 231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 803;